class Intro {
    constructor(parent, data) {
        this.init()
    }
    init() {
        const elIntro = document.querySelector('[data-intro]')
        if (null === elIntro) {
            return
        }

        const elMedia = elIntro.querySelector('[data-intro-media]')
        if (null === elMedia) {
            return
        }

        if (sessionStorage.getItem('introplay')) {
            if ('true' === sessionStorage.getItem('introplay')) {
                elIntro.classList.add('intro--end')
                this.remove(elMedia)
                return;
            }
        }

        document.body.style.overflow = 'hidden'
        elMedia.addEventListener('canplay', () => {
            elMedia.play()
        })
        elMedia.addEventListener('loadedmetadata', () => {
            elMedia.play()
        })
        elMedia.addEventListener('ended', () => {
            document.body.style.overflow = ''
            elIntro.classList.add('intro--end')
            sessionStorage.setItem('introplay', 'true')
        })
        elMedia.parentElement.addEventListener('transitionend', () => {
            this.remove(elMedia)
        })
        elIntro.addEventListener('click', () => {
            elMedia.pause();
            document.body.style.overflow = ''
            elIntro.classList.add('intro--end')
            sessionStorage.setItem('introplay', 'true')
        })
        elMedia.src = elMedia.dataset.src
    }

    remove(el) {
        el.parentElement.remove()
    }
}

export default Intro